import { useAppContext } from "@examspark/common-app";

import { useLocalStorage } from "./useLocalStorage";

type UseState<TValue> = [value: TValue, setValue: (value: TValue) => void];

const createFullKey = (
  key: string | undefined,
  appId: string | undefined,
  workspaceId: string | undefined,
  userId: string | undefined,
) => {
  if (key == null) return undefined;

  return ["state", key, appId, workspaceId, userId].join(":");
};

export function useStickyState<TValue>(
  key: string | undefined,
): UseState<TValue | undefined>;
export function useStickyState<TValue>(
  key: string | undefined,
  initialValue: TValue,
): UseState<TValue>;
export function useStickyState<TValue>(
  key: string | undefined,
  initialValue?: TValue,
): UseState<TValue | undefined> {
  const [state] = useAppContext();
  const fullKey = createFullKey(
    key,
    state.app?.id,
    state.workspace?.id,
    state.user?.id,
  );
  return useLocalStorage(fullKey, initialValue);
}
